<template>
  <div v-if="posts && posts.length" v-ssr-class>
    <swiper
      class="posts-slider__swiper"
      v-bind="currentOptions as any"
      @swiper="setInstance"
    >
      <swiper-slide
        v-for="post in posts"
        :key="post.slug"
        class="posts-slider__slide"
      >
        <post-card :blog-post="post" />
      </swiper-slide>
    </swiper>
    <div class="posts-slider__navigations-wrapper">
      <swiper-navigations
        v-if="swiperInstance"
        :instance="swiperInstance"
        class="posts-slider__navigations"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import type { SwiperOptions } from "swiper/types";
import { DEFAULT_BREAKPOINTS_CONFIG } from "~/composables/useViewportObserver/config";
import type { CmsPage } from "~/types/strapi/collection-types/CmsPage";
import PostCard from "~/modules/blog/components/PostCard.vue";

defineProps<{
  posts: CmsPage[];
}>();

const { setInstance, swiper: swiperInstance } = useSwiperInstance();
const currentOptions = ref<SwiperOptions>({
  slidesPerView: 1.5,
  spaceBetween: 20,
  breakpoints: {
    [DEFAULT_BREAKPOINTS_CONFIG.sm]: {
      slidesPerView: 3.5,
      spaceBetween: 24,
    },
    [DEFAULT_BREAKPOINTS_CONFIG.lg]: {
      slidesPerView: 4.5,
      spaceBetween: 24,
    },
  },
});
</script>
<style lang="scss">
.posts-slider {
  &__swiper {
    @apply overflow-y-visible p-2;
  }
  &__slide {
    @apply h-auto;
  }
}
</style>
